import apiClient from "../../api/apiClient";
import { getTenant } from "../../utils/tenantManager";

// ================= HELPER =================
const requireTenant = (): string => {
  const tenant = getTenant();
  if (!tenant) throw new Error("Tenant not selected");
  return tenant;
};

// ================= GET USERS =================
export const getUsersApi = async (
  search: string = "",
  page: number = 1,
  size: number = 10
) => {
  const tenantId = getTenant();

  const res = await apiClient.get("/Accounts/users", {
    params: {
      SearchString: search,
      CurrentPage: page,
      PageSize: size,
      TenantId: tenantId,
    },
  });

  return res.data;
};

// ================= GET ROLES =================
export const getRolesApi = async () => {
  const res = await apiClient.get("/Accounts/roles");
  return res.data;
};

// ================= CREATE USER =================
export const createUserApi = async (data: any) => {
  const tenantId = requireTenant();

  const res = await apiClient.post("/Accounts/register-admin", {
    ...data,
    tenantId,
  });

  return res.data;
};

// ================= GET USER BY ID =================
export const getUserByIdApi = async (id: string) => {
  const tenantId = requireTenant();

  const res = await apiClient.get(`/Accounts/user/${id}`, {
    params: { tenantId },
  });

  return res.data;
};

// ================= UPDATE USER =================
export const updateUserApi = async (data: any) => {
  const tenantId = requireTenant();

  const res = await apiClient.put("/Accounts/user", {
    ...data,
    tenantId,
  });

  return res.data;
};

// ================= DELETE USER =================
export const deleteUserApi = async (id: string) => {
  const tenantId = requireTenant();

  const res = await apiClient.delete(`/Accounts/user/${id}`, {
    params: { tenantId },
  });

  return res.data;
};

// ================= REVOKE SESSIONS =================
export const revokeSessionsApi = async (userId: string) => {
  const tenantId = requireTenant();

  const res = await apiClient.post(
    `/Accounts/revoke-sessions/${userId}`,
    null,
    {
      params: { tenantId },
    }
  );

  return res.data;
};